"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ButtonContainer=void 0;const ButtonContainer=exports.ButtonContainer=_styledComponents.default.div`
  .remove {
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid transparent;
    padding: 0px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    background: none;
    color: #7B1A27;
    font-size: 16px;
  }
`;